/**
 * Labstep
 *
 * @module components/File/TypeImage
 * @desc An image showing the file type
 */

import type React from 'react';
import { Image } from 'semantic-ui-react';
import type { FileTypeImageProps } from './types';

export const FileTypeImage: React.FC<FileTypeImageProps> = ({
  file,
  size,
}) => <Image src={file.iconPath} size={size} />;

FileTypeImage.defaultProps = {
  size: 'small',
};
